module.exports = __webpack_public_path__ + "static/media/onboarding1.9d84cfc9.svg";